import { CustomImage } from 'components/common/imgComponents/CustomImg/styles';
import styled from 'styled-components';

export const StyledCustomImage = styled(CustomImage)`
    display: inline-block;
    margin-left: 5px;
    margin-bottom: -1px;
`;
